import { useMemo } from 'react';

import { Flex } from '@chakra-ui/react';
import { useAuthenticatedUser } from 'components/hooks/dataHooks';

import { LevelUpIcon } from 'assets/assetsV1/iconComponents';

import { SkeletonLoader } from 'uiToolkitV1/SkeletonLoader';

import { MySummaryCardTemplate } from '../MySummaryCardTemplate';
import { CompetenciesMySummaryRow } from './CompetenciesMySummaryCard';
import { useMySummaryCompetency } from './hooks';

const AllCompetenciesSummaryCard = ({ setShowAllCompetenciesCard, openNonLevelUpCompetencySidePanel = () => {} }) => {
  const {
    user: { id },
  } = useAuthenticatedUser();
  const { data, isLoading, isError } = useMySummaryCompetency({
    limit: 50,
    offset: 0,
    employeeId: id,
  });

  const jobCompetencies = useMemo(
    () => [
      {
        competencies: data?.competencies,
      },
    ],
    [data]
  );

  if (isLoading) {
    return (
      <MySummaryCardTemplate
        Icon={LevelUpIcon}
        heading="Competencies"
        viewAllText="View All Competencies"
        onClickViewAll={setShowAllCompetenciesCard?.toggle}
      >
        <Flex
          p="24px 20px"
          sx={{
            '.chakra-stack': {
              width: '100%',
            },
          }}
        >
          <SkeletonLoader />
        </Flex>
      </MySummaryCardTemplate>
    );
  }

  return (
    <MySummaryCardTemplate
      Icon={LevelUpIcon}
      heading="Competencies"
      viewAllText="View All Competencies"
      onClickViewAll={setShowAllCompetenciesCard?.toggle}
      showViewAllButton={false}
    >
      {jobCompetencies[0]?.competencies?.map(
        (
          { levelUpCompetencyId, competencyId, name, targetPeriodStart, progressPercentage, progress, progressDetails },
          index
        ) => (
          <CompetenciesMySummaryRow
            levelUpCompetencyId={levelUpCompetencyId}
            competencyId={competencyId}
            name={name}
            targetPeriodStart={targetPeriodStart}
            progressPercentage={progressPercentage}
            progress={progress}
            key={`${competencyId}-${index}-competency-row`}
            //   handleOpenLevelUpSidePanel={handleOpenLevelUpSidePanel}
            levelUpId={jobCompetencies[0]?.levelUpId}
            showDivider={index < jobCompetencies[0]?.competencies?.length - 1}
            openNonLevelUpCompetencySidePanel={openNonLevelUpCompetencySidePanel}
            progressDetails={progressDetails}
          />
        )
      )}
    </MySummaryCardTemplate>
  );
};
export { AllCompetenciesSummaryCard };
